import Head from "next/head";
import { isLoggedIn } from "@utils/user/userCheck";
import { getSingleBlogPost } from "@queries/blogs.queries";
import { useContext, useEffect, useState } from "react";
import { Store } from "@store";
import SingleBlogView from "src/blogModule/views/SingleBlogView";
import { useRouter } from "next/router";
import { appBaseUrl } from "@utils/BASE-URL";
import { getBlogMetaData } from "@utils/blogs/utils";
import {
  generateSchemaForBlog,
  generateSchemaForFAQ,
} from "@utils/seo/generateScript";
import { useTranslation } from "react-i18next";

export default function SingleBlog({ blogData, userData, lang }) {
  const { t } = useTranslation();
  const { dispatch } = useContext(Store);
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState("");

  // console.log("SingleBlog => ", blogData);

  // const urlExtension = router.query.params[0];
  // const [bData, setbData] = useState(blogData);
  // const [metaData, setMetaData] = useState(getBlogMetaData(blogData));
  // const [seoData, setSeoData] = useState(
  //   generateSchemaForBlog({
  //     ...metaData,
  //     author_name: blogData.User.name,
  //   })
  // );

  // useEffect(() => {
  //   const fetchBlogData = async () => {
  //     const { data, err } = await getSingleBlogPost({
  //       //blogID: id,
  //       urlExtension,
  //       language: router.locale,
  //       // accessToken: userData.accessToken,
  //     });

  //     if (!err || data) {
  //       setbData(data);
  //       const tMetaData = getBlogMetaData(data);
  //       setMetaData(tMetaData);
  //       setSeoData(
  //         generateSchemaForBlog({
  //           ...tMetaData,
  //           author_name: data.User.name,
  //         })
  //       );
  //     }
  //   };
  //   fetchBlogData();
  // }, [router.locale]);

  const metaData = getBlogMetaData(blogData);
  const seoData = generateSchemaForBlog({
    ...metaData,
    author_name: blogData.mainBlog?.User.name,
  });

  useEffect(() => {
    dispatch({ type: "SET_DATA", payload: { userData, lang } });
    setCurrentUrl(window.location.href);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Head>
        <title>{`${blogData.mainBlog.headline} | ${t("utsav-hindu-temple-online-puja-and-prasad")}`}</title>
        <meta
          property="og:site_name"
          content={t("utsav-hindu-temple-online-puja-and-prasad")}
        />
        <meta property="og:type" content="article" />
        <meta
          property="article:published_time"
          content={metaData.published_time}
        />
        <meta
          property="title"
          content={`${metaData.headline} | ${t("by")} ${
            blogData.mainBlog.User.name
          } | ${t("utsav-hindu-temple-online-puja-and-prasad")} | ${
            blogData.mainBlog.keywords
              ? blogData.mainBlog.keywords
              : `${t(
                  "utsav-utsavapp-spiritual-blog-dharmik-blog-online-puja-booking-online-puja-online-video-darshan-hinduism-sanatan-dharma-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
                )}`
          }`}
        />
        <meta
          property="og:title"
          content={`${metaData.headline} | ${t("by")} ${
            blogData.mainBlog.User.name
          } | ${t("utsav-hindu-temple-online-puja-and-prasad")} `}
        />

        <meta
          name="description"
          content={`${
            blogData.mainBlog.metadata
              ? blogData.mainBlog.metadata
              : `${t(
                  "utsav-utsavapp-spiritual-blog-dharmik-blog-online-puja-booking-online-puja-online-video-darshan-hinduism-sanatan-dharma-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
                )}`
          }`}
        />
        <meta
          property="og:description"
          content={`${
            blogData.mainBlog.metadata
              ? blogData.mainBlog.metadata
              : `${t(
                  "utsav-utsavapp-spiritual-blog-dharmik-blog-online-puja-booking-online-puja-online-video-darshan-hinduism-sanatan-dharma-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
                )}`
          }`}
        />
        <meta
          property="og:url"
          content={metaData.pageUrl}
        />

        <meta
          property="og:image"
          content={metaData.img}
          alt={
            metaData.headline
              ? metaData.headline + `${t("blog-image")}`
              : `${t("utsav-blog-image-0")}`
          }
        />
        <meta
          name="twitter:image:src"
          content={metaData.img}
          alt={
            metaData.headline
              ? metaData.headline + `${t("blog-image")}`
              : `${t("utsav-blog-image-0")}`
          }
        />
        <meta
          property="og:image:alt"
          content={
            metaData.headline
              ? metaData.headline + `${t("blog-image")}`
              : `${t("utsav-blog-image-0")}`
          }
        />

        <meta property="og:image:width" content="750" />
        <meta property="og:image:height" content="550" />

        <meta property="article:publisher" content={t("utsav-app")} />
        <meta property="article:author" content={metaData.author_name} />
        <meta name="author" content={blogData.mainBlog.User.name} />
        <meta
          name="keywords"
          content={
            blogData.mainBlog.keywords
              ? blogData.mainBlog.keywords
              : `${t(
                  "utsav-utsavapp-spiritual-blog-dharmik-blog-online-puja-booking-online-puja-online-video-darshan-hinduism-sanatan-dharma-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
                )}`
          }
        />
        {/* <meta property="og:title" content="Utsav App: Know your Community" /> */}

        {/* =====Need to be changed============= */}
        <meta property="al:android:package" content="com.applex.utsav" />
        <meta property="fb:app_id" content="463332665401900" />
        <meta
          property="al:android:app_name"
          content={t("utsav-my-temple-and-festivals")}
        />

        {/* =====Need to be changed============= */}

        <meta property="twitter:title" content={metaData.headline} />
        <meta name="twitter:site" content="@utsav_app" />
        <meta property="twitter:description" content={metaData.blogContent} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Reading time" />
        <meta name="twitter:data1" content={`${metaData.read_time} min read`} />

        <link rel="icon" href="/favicon.ico" />

        <link
          rel="author"
          href={`${appBaseUrl}/${router.locale}/profile/${blogData.mainBlog.uid}/${metaData.author_name}`}
        />

        {/* <link rel="canonical" href={metaData.pageUrl} /> */}
        {currentUrl.includes("/en/") && (
          <link
            rel="canonical"
            href={metaData.pageUrl}
            // href={`${appBaseUrl}/blog/${blogData.mainBlog.BlogCategoryRelations[0]?.BlogCategory?.blogCategoryUrlExtension}/${blogData.mainBlog.urlExtension}`}
          />
        )}
        <link
          rel="alternate"
          href={metaData.pageUrl}
          hrefLang={router.locale}
        />
        <link rel="alternate" href={metaData.pageUrl} hrefLang="x-default" />

        {seoData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(seoData),
            }}
          />
        )}

        {blogData.mainBlog.Faqs?.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(
                generateSchemaForFAQ(blogData.mainBlog.Faqs)
              ),
            }}
          />
        )}
      </Head>

      <SingleBlogView
        data={blogData}
        for="SingleBlogView"
        commentValue={true}
        deleteBlogLocally={() => router.replace("/blogs")}
      />
    </div>
  );
}

export async function getServerSideProps(context) {
  try {
    const { req, res, params, locale } = context;
    const urlExtension = params?.blogUrl;
    const categoryUrl = params?.categoryUrl;

    const result = await isLoggedIn(req.headers.cookie, res);
    const userData = result.data;
    const lang = locale;

    //printInConsole("userData => ", result)

    const { data, err, code } = await getSingleBlogPost({
      //blogID: id,
      urlExtension,
      language: lang,
      accessToken: userData.accessToken,
    });

    // console.log("categoryUrl", categoryUrl, data, code);

    if (code === 301) {
      return {
        redirect: {
          destination: data.redirectedUrl,
          permanent: true,
        },
      };
    }

    if (
      (!categoryUrl || categoryUrl === "undefined") &&
      data &&
      data.mainBlog.BlogCategoryRelations.length > 0
    ) {
      let blogCategoryUrlExtension =
        data.mainBlog.BlogCategoryRelations[0].BlogCategory
          .blogCategoryUrlExtension;

      return {
        redirect: {
          destination: `/blog/${blogCategoryUrlExtension}/${urlExtension}`,
          permanent: true,
        },
      };
    }

    if (err || !data) {
      return {
        redirect: {
          destination: "/home",
          permanent: false,
        },
      };
    }

    return {
      props: {
        blogData: data,
        userData: userData,
        lang: lang,
      },
    };
  } catch (err) {
    // console.error(err);
    return {
      redirect: {
        destination: "/home",
        permanent: false,
      },
    };
  }
}
